import { AnalyticsEvent } from "@/services/tracking/types/analyticsEvent";
import * as WindowManagement from "@/services/windowManagement";
import { WindowKeys } from "@/services/windowManagement";

interface TrackingUtils {
    track: (event: AnalyticsEvent) => void;
}

let warningLogged = false;

const extractGoogleAnalyticsUserIdFromCookie = (gaCookie: string) => {
    if (gaCookie) {
        // Remove the Google Analytics tracker from the device ID.
        const userIdParts = gaCookie.split(".").slice(-2);
        if (userIdParts.length === 2) {
            return userIdParts.join("_");
        }
    }
    return undefined;
};

const getBrowserCookie = (cookieName: string) => {
    if (typeof document !== "object" || typeof document.cookie !== "string") {
        return undefined;
    }
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return undefined;
};

export const track = (event: AnalyticsEvent) => {
    const tracker: TrackingUtils = WindowManagement.getObject(
        WindowKeys.TRACKER
    );
    if (tracker?.track) {
        tracker.track(event);
    } else if (!warningLogged) {
        warningLogged = true;
        console.log(
            "hubo: unable to track event, event data layer not available"
        );
    }
};

export const getGoogleAnalyticsUserIdFromBrowserCookie = (
    cookieName: string
) => {
    const browserCookie = getBrowserCookie(cookieName);

    if (!browserCookie) {
        return undefined;
    }

    return extractGoogleAnalyticsUserIdFromCookie(browserCookie);
};
